package com.patronat.top.core.domain.usecase.command.auth

import com.patronat.top.domain.usecase.Command
import com.patronat.top.dto.AuthMethod

data class LoginCommand(
    val login: String,
    val authMethod: AuthMethod = AuthMethod.PHONE
) : Command